import axios from 'axios'
import { environment } from '../config/environment'

const API = axios.create({
  baseURL: environment.apiUrl,
})

// Add token to requests
API.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

export interface AuthUser {
  id: string
  email: string
  username: string
}

export interface AuthResponse {
  token: string
  user: AuthUser
}

export const authService = {
  register: async (email: string, username: string, password: string): Promise<AuthResponse> => {
    const response = await API.post('/api/auth/register', { email, username, password })
    return response.data
  },

  login: async (email: string, password: string): Promise<AuthResponse> => {
    const response = await API.post('/api/auth/login', { email, password })
    return response.data
  },

  logout: (): void => {
    localStorage.removeItem('authToken')
    localStorage.removeItem('authUser')
  },

  getToken: (): string | null => {
    return localStorage.getItem('authToken')
  },

  setToken: (token: string): void => {
    localStorage.setItem('authToken', token)
  },

  getUser: (): AuthUser | null => {
    const user = localStorage.getItem('authUser')
    return user ? JSON.parse(user) : null
  },

  setUser: (user: AuthUser): void => {
    localStorage.setItem('authUser', JSON.stringify(user))
  },

  isAuthenticated: (): boolean => {
    return !!localStorage.getItem('authToken')
  },
}
